import React from 'react';
import ProductDetails from './ProductDetails';

export default ({
  products = [],
  skuFilter
}) => {
  const filteredProducts = products.filter(p => !Boolean(skuFilter) || p.reference_id === skuFilter)

  return (
    <div style={{ display: 'flex', flexDirection: 'column', rowGap: '20px'}}>
    {filteredProducts.map((product) => 
        <ProductDetails key={product.id} product={product} />
    )}
    </div>
  )
}